var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-menu",attrs:{"type":"button","role":"button"}},[_c('a-icon',{staticClass:"mrg-right-4",attrs:{"type":"bars"}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }